<template>
    <div class="content">
        <div class="block block-rounded">
            <div class="block-header block-header-default">
                <h3 class="block-title">
                    {{ $t('title_update_shipment') }} <small>{{ shipment?.reference }}</small>
                </h3>
            </div>
            <div class="block-content">
                <ShipmentForm :shipment="shipment"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ShipmentForm from './components/ShipmentForm.vue';

export default {
    name: 'Update Shipment',
    data() {
        return {
            shipment: null, // Will hold the shipment data
        };
    },
    mounted() {
    const pathSegments = window.location.pathname.split('/');
    const shipment_id = pathSegments[pathSegments.length - 1]; // get the last segment (the ID)
    this.getShipmentData(shipment_id);
},
    methods: {
        // Fetch the shipment data using the ID from the route parameters
        async getShipmentData(shipment_id) {
            await axios
                .post('/shipments/get-shipment-details', {
                    ShipmentId: shipment_id
                }, {
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    }
                })
                .then((res) => {
                    this.shipment = res.data;
                })
                .catch((err) => {
                    console.error('Failed to load shipment data:', err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    components: {
        ShipmentForm,
    },
};
</script>

<style scoped>
.new-page {
    padding: 20px;
}
</style>